/* Shipping nudge: small single products (and small bags) get a gentle push toward a routine, which ships free.
   Product page: under the Add to bag row on single products priced below the free-shipping line.
   Bag drawer: under the "away from free shipping" line while the bag is below it, and the "Complete your routine" picks
   lead with items that, added once, put the bag over the free-shipping line. */
(function(){
  if (window.__dbShipNudge) return;
  window.__dbShipNudge = true;
  var V = window.DanellaV4 || {};
  var FS = Number(V.freeShip) || 35;
  var LINK = '/collections/healthy-skin';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function css(){
    if (document.getElementById('db-nudge-css')) return;
    var s = document.createElement('style');
    s.id = 'db-nudge-css';
    s.textContent = '.db-nudge{margin:0 0 1.4rem;padding:1rem 1.2rem;background:#EAF4EC;border-radius:1rem;font-size:1.25rem;line-height:1.45;color:#283730}.db-nudge a{font-weight:800;color:inherit;text-decoration:underline;text-underline-offset:2px}.v4c__nudge{margin:0;padding:10px 20px;font-size:13px;line-height:1.4;color:#4b4b58;background:#EAF4EC;border-bottom:1px solid #ecebf1}.v4c__nudge a{font-weight:700;color:inherit;text-decoration:underline}.db-up__tag{display:block;margin-top:2px;font-size:11px;font-weight:700;color:#2f6b45}.db-buytrust{list-style:none;margin:0 0 1.2rem;padding:0;display:grid;gap:.5rem}.db-buytrust li{display:flex;gap:.7rem;align-items:flex-start;font-size:clamp(.95rem,3.05vw,1.2rem);line-height:1.35;color:#283730}.db-buytrust svg{flex:none;width:1.7rem;height:1.7rem;margin-top:0;fill:none;stroke:#2f6b45;stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round}.db-buytrust strong{font-weight:800}.db-buytrust a{color:inherit;text-decoration:underline;text-underline-offset:2px}.db-tier__was{display:block;font-size:.85em;font-weight:500;opacity:.6}';
    document.head.appendChild(s);
  }

  function isRoutinePage(h){
    return /^healthy-.+-routine$/.test(h) || /-routine$/.test(h) || /(^|-)(trio|box|set|bundle)(-|$)/.test(h);
  }

  function productNudge(){
    var m = /\/products\/([^\/?#]+)/.exec(window.location.pathname);
    if (!m || isRoutinePage(m[1])) return;
    if (document.querySelector('[data-db-nudge]')) return;
    var actions = document.querySelector('form[data-product-form] .product-form__actions');
    var priceEl = document.querySelector('[data-product-price]');
    if (!actions || !priceEl) return;
    var price = parseFloat((priceEl.textContent || '').replace(/[^0-9.]/g, ''));
    if (!(price > 0) || price >= FS) return;
    css();
    var d = document.createElement('div');
    d.className = 'db-nudge';
    d.setAttribute('data-db-nudge', '');
    d.innerHTML = 'Ships free over $' + FS + ' (otherwise $5.95). A routine ships free, and builds your whole skincare in the right order. <a href="' + LINK + '">See Healthy Skin routines</a>';
    var after = actions.nextElementSibling && actions.nextElementSibling.classList && actions.nextElementSibling.classList.contains('product-form__dynamic') ? actions.nextElementSibling : actions;
    after.parentNode.insertBefore(d, after.nextSibling);
  }

  /* Routine pages: two trust lines directly above the quantity + Add to bag row */
  function routineTrust(){
    var m = /\/products\/([^\/?#]+)/.exec(window.location.pathname);
    if (!m || !/-routine$/.test(m[1])) return;
    var actions = document.querySelector('form[data-product-form] .product-form__actions');
    if (!actions || actions.classList.contains('product-form__actions--launch')) return;
    var have = document.querySelector('[data-db-buytrust]');
    if (have) { if (have.nextElementSibling !== actions) actions.parentNode.insertBefore(have, actions); return; }
    css();
    var ul = document.createElement('ul');
    ul.className = 'db-buytrust';
    ul.setAttribute('data-db-buytrust', '');
    ul.innerHTML = '<li><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6h11v9H3zM14 9h4l3 3v3h-7z"></path><circle cx="7" cy="17" r="1.8"></circle><circle cx="17" cy="17" r="1.8"></circle></svg><span><strong>Ships free over $' + FS + '.</strong> This routine qualifies.</span></li>'
      + '<li><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3l7 3v5c0 4.5-3 8-7 10-4-2-7-5.5-7-10V6l7-3z"></path><path d="M8.7 12.2l2.3 2.3 4.3-4.6"></path></svg><span><a href="/pages/authenticity-promise"><strong>100% authentic.</strong></a> Sourced from K-beauty suppliers.</span></li>';
    actions.parentNode.insertBefore(ul, actions);
  }

  /* Links with ?variant= (ads, emails): make the photo match the pre-selected size */
  function variantSync(){
    if (!/[?&]variant=/.test(window.location.search)) return;
    var sel = document.querySelector('select[data-variant-select]');
    if (!sel) return;
    sel.dispatchEvent(new Event('change', { bubbles: true }));
    setTimeout(function(){ var sp = document.querySelector('[data-sticky-price]'); if (sp) sp.removeAttribute('data-dls'); }, 100);
  }

  /* Routines in the sale: the size cards show the sale price with the regular price crossed out */
  function tierSale(){
    if (!window.DanellaSale || !document.querySelector('.main-product .price[data-dl-routine]')) return;
    var pct = Number(window.DanellaSale.routine) || 0;
    if (!pct) return;
    css();
    document.querySelectorAll('.db-tier__price:not([data-dbs])').forEach(function(el){
      var m = (el.textContent || '').replace(/,/g, '').match(/\d+(?:\.\d+)?/);
      if (!m) return;
      var c = Math.round(parseFloat(m[0]) * 100);
      el.setAttribute('data-dbs', '1');
      el.innerHTML = money(c - Math.round(c * pct / 100)) + ' <s class="db-tier__was">' + money(c) + '</s>';
    });
  }

  /* The sheet-mask card on routine pages: show the 20% single-product sale price even if the card was drawn before the sale script ran */
  function maskSale(){
    if (!window.DanellaSale) return;
    var pct = Number(window.DanellaSale.single) || 0;
    var el = document.querySelector('.db-mask__price');
    if (!pct || !el || el.querySelector('s')) return;
    var m = (el.textContent || '').replace(/,/g, '').match(/\d+(?:\.\d+)?/);
    if (!m) return;
    var c = Math.round(parseFloat(m[0]) * 100);
    el.innerHTML = '<s>' + money(c) + '</s>' + money(c - Math.round(c * pct / 100));
  }

  function bagNudge(){
    var ship = document.querySelector('#V4Cart .v4c__ship');
    if (!ship) return;
    var has = ship.nextElementSibling && ship.nextElementSibling.classList && ship.nextElementSibling.classList.contains('v4c__nudge');
    var under = /away from/i.test(ship.textContent || '');
    if (under && !has) {
      css();
      var p = document.createElement('p');
      p.className = 'v4c__nudge';
      p.innerHTML = 'Short on ideas? <a href="' + LINK + '">Shop Healthy Skin routines</a>. They ship free.';
      ship.parentNode.insertBefore(p, ship.nextSibling);
    } else if (!under && has) {
      ship.nextElementSibling.remove();
    }
  }

  /* Bag picks that unlock free shipping */
  var QA = String.fromCharCode(34), QS = String.fromCharCode(39);
  function esc(s){ return String(s == null ? '' : s).split('&').join('&amp;').split('<').join('&lt;').split('>').join('&gt;').split(QA).join('&quot;').split(QS).join('&#39;'); }
  function money(c){ var d = c / 100; return '$' + (d % 1 === 0 ? d.toFixed(0) : d.toFixed(2)); }
  function cents(p){ if (typeof p === 'string' && p.indexOf('.') > -1) return Math.round(parseFloat(p) * 100); return Number(p) || 0; }
  function sized(u, w){ if (!u) return ''; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function skip(p){ return /bundle|gift set/i.test(p.type || '') || p.vendor === 'Danella Beauty'; }
  function giftItem(i){ return !!(i.properties && (i.properties._gift || i.properties.Gift)); }
  var recCache = {}, upBusy = false;

  function getJson(url){
    return fetch(url, { headers: { Accept: 'application/json' } }).then(function(r){ return r.ok ? r.json() : {}; }).catch(function(){ return {}; });
  }
  function recsFor(pid){
    if (recCache[pid]) return recCache[pid];
    var base = ROOT + 'recommendations/products.json?product_id=' + pid + '&limit=10&intent=';
    recCache[pid] = getJson(base + 'complementary').then(function(j){
      var l = j.products || [];
      return l.length ? l : getJson(base + 'related').then(function(k){ return k.products || []; });
    });
    return recCache[pid];
  }

  function upsell(){
    var slot = document.querySelector('#V4Cart [data-v4c-recs]');
    if (!slot || upBusy || slot.querySelector('[data-db-up]')) return;
    upBusy = true;
    getJson(ROOT + 'cart.js').then(function(cart){
      var gap = FS * 100 - (cart.total_price || 0);
      var items = (cart.items || []).filter(function(i){ return !giftItem(i); });
      if (!(gap > 0) || !items.length) return;
      var inCart = {};
      (cart.items || []).forEach(function(i){ inCart[i.product_id] = 1; });
      return recsFor(items[0].product_id).then(function(list){
        var saleOn = !!(V.ssOn && V.ssOn());
        var ok = [];
        list.forEach(function(p){
          var vr = p.variants && p.variants[0];
          if (!vr || vr.available === false || inCart[p.id] || skip(p)) return;
          var full = cents(vr.price);
          ok.push({ p: p, vr: vr, full: full, sale: saleOn ? full : Math.round(full * 0.8) });
        });
        var yes = ok.filter(function(o){ return o.sale >= gap; }).sort(function(a, b){ return a.sale - b.sale; });
        if (!yes.length) return;
        var rest = ok.filter(function(o){ return o.sale < gap; });
        var pick = yes.slice(0, 2).concat(yes.slice(2), rest).slice(0, 3);
        var now = document.querySelector('#V4Cart [data-v4c-recs]');
        if (!now) return;
        css();
        var h = '<div class="v4c__recs" data-db-up><p class="v4c__recs-title">Add one for free shipping</p>';
        pick.forEach(function(o){
          var p = o.p, img = p.featured_image || (p.images && p.images[0]) || '';
          if (img && img.src) img = img.src;
          var tag = o.sale >= gap ? '<span class="db-up__tag">Unlocks free shipping</span>' : '';
          h += '<div class="v4c__rec"><a class="v4c__rimg" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(sized(img, 160)) + '" alt="" width="56" height="56" loading="lazy">' : '') + '</a><div class="v4c__rinfo"><p class="v4c__vendor">' + esc(p.vendor) + '</p><a href="' + esc(p.url) + '" class="v4c__rname">' + esc(p.title) + '</a><span class="v4c__rprice"><s>' + money(o.full) + '</s> <b>' + money(o.sale) + '</b></span>' + tag + '</div><button type="button" class="v4c__radd" data-v4c-add="' + o.vr.id + '" aria-label="Add ' + esc(p.title) + '">+</button></div>';
        });
        now.innerHTML = h + '</div>';
      });
    }).then(function(){ upBusy = false; }, function(){ upBusy = false; });
  }

  function run(){ productNudge(); routineTrust(); variantSync(); tierSale(); maskSale(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  setTimeout(run, 1200);
  setTimeout(tierSale, 400);
  setTimeout(function(){ routineTrust(); maskSale(); }, 3000);

  var pending = false;
  new MutationObserver(function(){
    if (pending) return;
    pending = true;
    setTimeout(function(){ pending = false; bagNudge(); upsell(); }, 60);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
